export enum TypeCoupon {
  Promo,      // 0 — coupon ambassadeur legacy (userId requis)
  Reduction,  // 1 — coupon lié à un plan spécifique (rateId requis, legacy)
  Marketing,  // 2 — coupon universel, % de remise tous plans (rateId=null)
}
